import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@nextui-org/button'
import { headerStyles } from './styles'

const textLabels = {
  credito_clp: '',
  credito_uf: 'Valor máximo de tu propiedad',
  financiamiento_porcentaje: 'Financiamiento (%)',
  cae: 'CAE Tasa de interés',
  valor_casa: 'Tu monto a financiar es de',
  monto_pie: 'Debes tener un ahorro previo o pie de',
  dividendo: '',
  renta_requerida: '',
  duracion_anios: 'En un plazo de',
}

const firstCardLabels = [
  'credito_uf',
  'valor_casa',
  'monto_pie',
  'financiamiento_porcentaje',
  'cae',
]
const secondCardLabels = ['dividendo', 'renta_requerida', 'duracion_anios']

const formatResult = (objeto, exclusiones = []) => {
  return Object.entries(objeto)
    .filter(([clave]) => !exclusiones.includes(clave))
    .map(([clave, valor]) => ({ text: clave, value: valor }))
}

const Result = ({ result, resetSimulator }) => {
  const url = 'https://ww2.propital.com/asesor%C3%ADa-inmobiliaria-invertir'

  const items = formatResult(result, [
    'broker_email',
    'fecha_edicion',
    'sw_propiedad_divisa',
    'credito_final',
    'cuota_mensual',
    'total_uf',
    'financiamiento',
    'numero_total_pagos',
    'valor_uf',
    'tipo_interes_activo',
  ])

  const formatValue = (item) => {
    const creditoCLP = items.find((i) => i.text === 'credito_clp')?.value || ''

    if (item?.text === 'duracion_anios') {
      return `${item?.value} años`
    } else if (item?.text === 'financiamiento_porcentaje') {
      return `${item?.value} %`
    } else if (item?.text === 'credito_uf') {
      return `${item?.value} equivalente a ${creditoCLP}`
    } else {
      return item?.value
    }
  }

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col mx-auto space-y-6 md:flex-row md:space-y-0 md:space-x-6 w-max">
        {[firstCardLabels, secondCardLabels].map((labels, cardIndex) => (
          <div key={cardIndex} className="w-full p-6 border-2 rounded-3xl border-primary">
            {labels.map((label, index) => {
              const item = items.find((item) => item.text === label)
              const isSpecialItem = ['dividendo', 'renta_requerida'].includes(item?.text)
              return (
                <div className="flex-col text-center" key={index}>
                  <h6 className={`font-bold text-primary ${index !== 0 && 'mt-3'}`}>
                    {item?.text === 'dividendo' ? (
                      <>
                        <span>Pagarías mensualmente</span>
                        <br />
                        <span>un dividendo de:</span>
                      </>
                    ) : item?.text === 'renta_requerida' ? (
                      <>
                        <span>Necesitas un sueldo </span>
                        <br />
                        <span>líquido de:</span>
                      </>
                    ) : (
                      <>{textLabels[item?.text] || item?.text}:</>
                    )}
                  </h6>

                  <div
                    className={`${
                      isSpecialItem
                        ? 'bg-[#fc2cd2] px-2 py-2 w-fit mx-auto mt-3 text-white rounded-3xl'
                        : 'text-gray-500'
                    }`}
                  >
                    <strong>{formatValue(item)}</strong>
                  </div>
                </div>
              )
            })}
          </div>
        ))}
      </div>
      <div className={`${headerStyles.BUTTON}`}>
        <a href={url} target="_blank" rel="noopener noreferrer">
          <Button
            type="submit"
            color="primary"
            size="lg"
            className="rounded-3xl font-bold bg-[#fc2cd2] w-full text-lg"
          >
            Quiero Invertir
          </Button>
        </a>
        <Button
          type="submit"
          color="primary"
          size="lg"
          className="text-lg font-bold rounded-3xl"
          variant="shadow"
          onClick={() => resetSimulator()}
        >
          Hacer otra simulación
        </Button>
      </div>
    </div>
  )
}

Result.propTypes = {
  result: PropTypes.object.isRequired,
  resetSimulator: PropTypes.func.isRequired,
}

export default Result
